import React, { useContext, useEffect, useState } from "react";
import "./Application.css";
import "./Desktop/Desktop.css";
import { AppContext } from "../../AppContext";
import Account from "./Account/Account";
import accountSvg from "../../assets/accountSvg";
import GeneratePreApprovalModal from "./Clients/GeneratePreApproval/GeneratePreApprovalModal";
import WorkshopMaterials from "./BeOneTeam/WorkshopMaterials";
import Clients from "./Clients/Clients";
import LoginModal from "./Account/LoginPanel/LoginModal/LoginModal";
import PreApprovedListModal from "./Account/AccountModals/PreApprovedListModal";
import UCCListModal from "./Account/AccountModals/UCCListModal";
import { logActivity } from "../utils";
import Pipeline from "../Pipeline/Pipeline";
import { PipelineButtonContext } from "../Pipeline/PipelineButtonContext";

const Application = () => {
  const {
    path,
    setPath,
    windowWidth,
    headerLogo,
    userEmail,
    userType,
    navbar,
    midbar,
    makeKey,
    appMode,
    navigate,
    setClientSelection,
    pendingClientCount,
    preapprovedClientCount,
    transactionsUnderContractCount,
    userCompany,
  } = useContext(AppContext);

  useEffect(() => {
    //Set newly selected route to top of scroll on path change
    if (windowWidth < 750) {
      document.querySelector("#mobile-mid-bar").scrollTo(0, 0);
    }
  }, [path]);

  let pipelinePosition = "desktop-container";
  let accountPosition = "mid-bar";
  if (windowWidth < 750) {
    if (path == "/home" || !userEmail) {
      pipelinePosition = "hidden";
      accountPosition = "mid-bar";
    } else {
      pipelinePosition = "mid-bar";
      accountPosition = "hidden";
    }
  } else {
    pipelinePosition = "desktop-container";
    accountPosition = "mid-bar";
  }

  const pendingSvg = (
    <svg
      className="nav-icon"
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 -960 960 960"
      width="24"
    >
      <path d="M680-80q-83 0-141.5-58.5T480-280q0-83 58.5-141.5T680-480q83 0 141.5 58.5T880-280q0 83-58.5 141.5T680-80Zm67-105 28-28-75-75v-112h-40v128l87 87Zm-547 65q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h167q11-35 43-57.5t70-22.5q40 0 71.5 22.5T594-840h166q33 0 56.5 23.5T840-760v250q-18-13-38-22t-42-16v-212h-80v120H280v-120h-80v560h212q7 22 16 42t22 38H200Zm280-640q17 0 28.5-11.5T520-800q0-17-11.5-28.5T480-840q-17 0-28.5 11.5T440-800q0 17 11.5 28.5T480-760Z" />
    </svg>
  );

  const preApprovalsSvg = (
    <svg
      className="nav-icon"
      xmlns="http://www.w3.org/2000/svg"
      height="48"
      width="48"
    >
      <path d="M11.1 37.3 4 30.2l2.1-2.1 5 4.95 8.95-8.95 2.1 2.15Zm0-16L4 14.2l2.1-2.1 5 4.95 8.95-8.95 2.1 2.15ZM26 33.5v-3h18v3Zm0-16v-3h18v3Z" />
    </svg>
  );
  const underContractSvg = (
    <svg
      className="nav-icon"
      xmlns="http://www.w3.org/2000/svg"
      height="48"
      width="48"
    >
      <path d="M38.5 30.25v-16.1L28 6.8l-10.5 7.35v6.45h-3v-7.95L28 3l13.5 9.65v17.6ZM28 6.8ZM29 17h2v-2h-2Zm-4 0h2v-2h-2Zm4 4h2v-2h-2Zm-4 0h2v-2h-2Zm3.3 23.9-15.55-4.45v2.85H2V23.6h15.45l12.75 4.8q1.35.5 2.275 1.625.925 1.125.925 3.225h5.7q2.1 0 3.5 1.5T44 38.8v1.3ZM5 40.3h4.7V26.6H5Zm23.1 1.5 12.8-3.9q-.3-.95-.75-1.3-.45-.35-1.05-.35H28.75q-1.5 0-2.775-.2t-2.425-.55l-4.05-1.25 1.1-2.9 3.65 1.2q1.25.4 2.375.55 1.125.15 3.575.15 0-.6-.225-1.175-.225-.575-.775-.825L16.95 26.6h-4.2v10.7ZM9.7 33.45Zm20.5-.2Zm-20.5.2Zm3.05 0Z" />
    </svg>
  );

  const navTab = (name, navIcon, urlPath, clientCount = 0) => {
    return (
      <div
        className={`nav-tab ${path === urlPath ? "selected" : null}`}
        onClick={() => {
          if (urlPath == "/pending") {
            setClientSelection("Pending");
            setDisplayComponent(<Clients />);
          }
          if (urlPath == "/preapproved") {
            setClientSelection("Pre Approved");
            setDisplayComponent(<Clients />);
          }
          setPath(urlPath);
          navigate(urlPath, { replace: true });
          logActivity({
            apiKey: makeKey,
            userEmail: userEmail,
            userType: userType,
            tab: "Navigation",
            action: `${name} Tab`,
            userCompany: userCompany,
          });
        }}
      >
        {path === urlPath ? <div className="selected-bar"></div> : null}
        {clientCount == 0 ? (
          navIcon
        ) : (
          <>
            {navIcon}
            <div className="navIcon clientCount">
              {clientCount >= 0 ? clientCount : null}
            </div>
          </>
        )}
        <span className="nav-text">{name}</span>
      </div>
    );
  };

  const [appLayout, setAppLayout] = useState("");

  useEffect(() => {
    appMode == "on" ? setAppLayout("appMode") : setAppLayout("");
  }, [appMode]);

  const [barPosition, setBarPosition] = useState("");
  const [pipelineExtended, setPipelineExtended] = useState("");

  useEffect(() => {
    userEmail ? setBarPosition("left") : setBarPosition("");
    setTimeout(() => {
      midbar.includes("extended")
        ? setPipelineExtended("extended")
        : setPipelineExtended("");
    }, 0);
  }, [userEmail, midbar]);

  const [buttonSelected, setButtonSelected] = useState("undercontract");
  const [displayComponent, setDisplayComponent] = useState(<></>);

  return (
    <div className={`Application-layout ${appLayout}`}>
      <div className="top-bar-inset"></div>
      <div className={`top-bar ${barPosition}`}>
        <img alt="Matrix Logo" className="matrix-logo" src={headerLogo} />
      </div>
      <div className={`${accountPosition} ${midbar} ${barPosition}`}>
        <PipelineButtonContext.Provider
          value={{
            buttonSelected,
            setButtonSelected,
            displayComponent,
            setDisplayComponent,
          }}
        >
          <Account />
        </PipelineButtonContext.Provider>
      </div>
      <div className={`${pipelinePosition} ${pipelineExtended}`} id="mobile-mid-bar">
        <PipelineButtonContext.Provider
          value={{
            buttonSelected,
            setButtonSelected,
            displayComponent,
            setDisplayComponent,
          }}
        >
          <Pipeline />
        </PipelineButtonContext.Provider>
      </div>
      <div className={navbar}>
        {navTab("Home", accountSvg, "/home")}
        {navTab("Pending Clients", pendingSvg, "/pending", pendingClientCount)}
        {navTab(
          "Pre-Approved",
          preApprovalsSvg,
          "/preapproved",
          preapprovedClientCount
        )}
        {navTab(
          "Transactions",
          underContractSvg,
          "/undercontract",
          transactionsUnderContractCount
        )}
      </div>
      <GeneratePreApprovalModal />
      <LoginModal />
      {userCompany == "Be1 Team" || userCompany == "Move Mortgage" || userCompany=="Sandoval Team"? (
        <WorkshopMaterials />
      ) : null}
      <PreApprovedListModal />
      <UCCListModal />
    </div>
  );
};

export default Application;
